import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../components/common/PageHeader";
import {
  getContactById,
  getVerticalList,
  getResponsibleUsers,
  getInquirySourceList,
} from "../api/contactService";
import { getClientSegmentByVertical } from "../../sales/inquiry/api/inquiry.api";

const ViewContact: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [contact, setContact] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const [usersByVertical, setUsersByVertical] = useState<any>({});
  const [segmentsByVertical, setSegmentsByVertical] = useState<any>({});
  const [verticalList, setVerticalList] = useState<any[]>([]);
const [inquirySources, setInquirySources] = useState<any[]>([]);
  /* ================= LOAD CONTACT ================= */
  useEffect(() => {
    if (id) fetchContact(Number(id));
  }, [id]);

  const fetchContact = async (contactId: number) => {
    try {
      setLoading(true);
      const res = await getContactById(contactId);
      setContact(res.data);
    } catch (err) {
      console.error("Failed to load contact", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
  const loadSources = async () => {
    try {
      const res = await getInquirySourceList();
      setInquirySources(res.data?.results || []);
    } catch (err) {
      console.error("Failed to load sources", err);
    }
  };

  loadSources();
}, []);
const getSourceName = (id: number) => {
  return inquirySources.find((s: any) => s.id === id)?.name || "—";
};

  /* ================= LOAD VERTICAL MASTER ================= */
  useEffect(() => {
    getVerticalList().then((res) => {
      setVerticalList(res.data?.results || []);
    });
  }, []);

  /* ================= LOAD USERS + SEGMENTS ================= */
  useEffect(() => {
    if (!contact || verticalList.length === 0) return;

    const loadData = async () => {
      const verticalKeys = [
        { key: "glazing", flag: contact.is_glazing },
        { key: "lixil", flag: contact.is_lixil },
        { key: "hunter", flag: contact.is_hunter_douglas },
      ];

      for (const v of verticalKeys) {
        if (!v.flag) continue;

        const vertical = verticalList.find((x: any) =>
          x.name.toLowerCase().includes(v.key)
        );

        if (!vertical) continue;

        const vId = vertical.id;

        // users
        const userRes = await getResponsibleUsers({ vertical_id: vId });
        setUsersByVertical((prev: any) => ({
          ...prev,
          [vId]: userRes.data?.data || [],
        }));

        // segments
        const segRes = await getClientSegmentByVertical(vId);
        setSegmentsByVertical((prev: any) => ({
          ...prev,
          [vId]: segRes.data?.results || [],
        }));
      }
    };

    loadData();
  }, [contact, verticalList]);

  /* ================= HELPERS ================= */
  const getName = (list: any[], id: number) => {
    return list?.find((x: any) => x.id === id)?.name || "—";
  };

  const getVerticals = () => {
    const vList: any[] = [];

    const pushVertical = (key: string, segmentId: number, userId: number) => {
      const vertical = verticalList.find((v: any) =>
        v.name.toLowerCase().includes(key)
      );

      if (!vertical) return;

      const vId = vertical.id;

      vList.push({
        name: vertical.name,
        segment: getName(segmentsByVertical[vId], segmentId),
        assigned: getName(usersByVertical[vId], userId),
      });
    };

    if (contact.is_glazing) {
      pushVertical(
        "glazing",
        contact.glazing_segment,
        contact.glazing_assigned_to
      );
    }

    if (contact.is_lixil) {
      pushVertical(
        "lixil",
        contact.lixil_segment,
        contact.lixil_assigned_to
      );
    }

    if (contact.is_hunter_douglas) {
      pushVertical(
        "hunter",
        contact.hunter_douglas_segment,
        contact.hunter_douglas_assigned_to
      );
    }

    return vList;
  };

  /* ================= LOADING ================= */
  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!contact) {
    return <div className="text-center mt-5">Contact not found</div>;
  }

  /* ================= UI ================= */
  return (
    <>
      <PageHeader
        title="View Contact"
        breadcrumbs={[
          { label: "Dashboard", path: "/dashboard" },
          { label: "Masters" },
          { label: "Contact Directory", path: "/masters/contact" },
          { label: "View Contact" },
        ]}
      />

      <div className="container mt-4">
        <div className="card common-form-card p-4">

          {/* BASIC INFO */}
          <Section title="Basic Info">
            <Info label="Name" value={contact.name} />
            <Info label="Mobile" value={contact.phone} />
            <Info label="Email" value={contact.email || "—"} />
            <Info label="Inquiry Source" value={getSourceName(contact.source)} />
          </Section>

          {/* COMPANY */}
          <Section title="Company Info">
            <Info label="Company" value={contact.company_name || "—"} />
            <Info label="Designation" value={contact.designation || "—"} />
          </Section>

          {/* ADDRESS */}
          <Section title="Address">
            <Info label="Address" value={contact.address || "—"} />
            <Info label="City" value={contact.city || "—"} />
            <Info label="State" value={contact.state || "—"} />
          </Section>
          {/* CONTACT DETAILS */}
{/* <Section title="Contact Details">
  {contact.contact_persons?.length ? (
    contact.contact_persons.map((c: any, index: number) => (
      <div key={index} className="row  pb-2 border-bottom">

        <Info label="Contact Name" value={c.name || "—"} />
        <Info label="Mobile" value={c.mobile || "—"} />
        <Info label="Email" value={c.email || "—"} />
        <Info label="Designation" value={c.designation || "—"} />

      </div>
    ))
  ) : (
    <div className="text-muted">No contact details available</div>
  )}
</Section> */}

          {/* VERTICAL DETAILS */}
          <Section title="Vertical Details">
            {getVerticals().length ? (
              getVerticals().map((v: any, index: number) => (
                <div key={index} className="row pb-2 border-bottom">
                  <Info label="Vertical" value={v.name} />
                  <Info label="Client Segment" value={v.segment} />
                  <Info label="Assigned To" value={v.assigned} />
                </div>
              ))
            ) : (
              <div className="text-muted">No vertical selected</div>
            )}
          </Section>

          {/* FOOTER */}
          <div className="d-flex justify-content-end mt-4">
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/masters/contact")}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewContact;

/* ===== HELPERS ===== */

const Section = ({ title, children }: any) => (
  <div className="form-section">
    <div className="form-section-header bg-primary text-white">
      {title}
    </div>
    <div className="row g-3 p-3">{children}</div>
  </div>
);

const Info = ({ label, value }: any) => (
  <div className="col-md-3">
    <div className="text-muted small">{label}</div>
    <div className="fw-semibold">{value}</div>
  </div>
);